





















import Vue from 'vue';
import ImageInfo from '@/types/ImageInfo.ts';
import ImageSlide from '@/components/ImageSlide.vue';

export default Vue.extend({
    name: 'ImageSlider',

    components: {
        ImageSlide
    },

    props: {
        images: {
            type: Array as () => ImageInfo[]
        }
    },

    watch: {
        images(newImages: ImageInfo[], oldImages: ImageInfo[]) {
            this.choosenIndex = 0;
        }
    },

    data() {
        return {
            choosenIndex: 0
        };
    },

    methods: {
        moveLeft() {
            if (this.choosenIndex === 0) {
                this.choosenIndex = this.images.length - 1;
            } else {
                this.choosenIndex--;
            }
        },

        moveRight() {
            if (this.choosenIndex === this.images.length - 1) {
                this.choosenIndex = 0;
            } else {
                this.choosenIndex++;
            }
        }
    }
});
